module.exports = __webpack_public_path__ + "img/ic_telegram.f8bd029e.png";